import WithRender from "../../templates/containers/packing3dButtons.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([])
  },
  props: ["hideContainer"]
});
